import { render, staticRenderFns } from "./MsLoading.vue?vue&type=template&id=376fe139&scoped=true"
import script from "./MsLoading.vue?vue&type=script&lang=js"
export * from "./MsLoading.vue?vue&type=script&lang=js"
import style0 from "./MsLoading.vue?vue&type=style&index=0&id=376fe139&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376fe139",
  null
  
)

export default component.exports